import { render, staticRenderFns } from "./SfList.vue?vue&type=template&id=f6150b76&"
import script from "./SfList.vue?vue&type=script&lang=js&"
export * from "./SfList.vue?vue&type=script&lang=js&"
import style0 from "./SfList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports